//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import * as axios from "@/store/http";
import * as auth from "@/utils/auth";
import CommFileUpload from "@/pccomponents/CommFileUpload";
import fileReplace from "@/pccomponents/FileReplace";
export default {
    extends: CommFileUpload,
    name: "FileUpload2",
    components: {fileReplace},
    props:{
        /**
         * 图片url路径
         */
        imageUrl:{
          type:String,
          default:""
        },
        prop:{
            type:String,
            default:""
        },
        label:{
            type:String,
            default:""
        },
        data:{
          type:null,
          default:""
        },
        formName:{
          type:String,
          default:"record"
        },
        fileForm: {
          type: Object,
          default: () => ({})
        },
        keyval:{
           type:String,
           default:""
        },
        matchItem:{
          type:String,
          default:""
        },
        replaceItem:{//替换编辑项
          type:String,
          default:""
        },
        editItem:{
          type:String,
          default:""
        },
        rules:{
          type: Array,
          default: () => []
        },
        // 数据对象
        dataObj:{
          type: Object,
          default: () => ({})
        },
        // 数据对象属性名
        dataObjAttr:{
          type: String,
          default: ""
        },
    },
    data(){
       return {
            getUpload: 'file/getfile'
       }
    },
    methods:{
      initFileConfig(){//初始化文件配置
        let url = "file/getDocuTypeInfo";
        let params = {
          record: {
            btype: this.fileForm.btype,
            docutypeid:this.fileForm.docutypeid,
          }
        };
        axios.post(url, params).then(res => {
          if(res.data.code=="1"){
            let docuinfo=res.data.data.record.docuinfo;
            if(docuinfo!=undefined){
              this.tagName=docuinfo.tagname;
              this.tabName=docuinfo.tabname;
              let limitnum=docuinfo.limitnum;
              if(limitnum!=""&&limitnum!=undefined){
                this.limitNum=limitnum;
              }
              this.acceptType=docuinfo.filetype;
              this.docuTypeId=docuinfo.docutypeid;
              if(this.isNotNullOrEmpty(docuinfo.maxsize)){
                 this.maxSize=docuinfo.maxsize+"";
              }
              this.chunkSize=docuinfo.chunksize;
              this.ifChunkSize=docuinfo.ifchunksize;
              this.btype=docuinfo.btype;
              if(this.limitNum==1){
                this.showmultiple=false;
              }
            }
            if(this.keyval!=""&&this.keyval!=undefined&&this.keyval!="0"){
              this.getupload();
            }
          }
        });
      },
      async getupload(){
            let params = {
              record: {
                btype: this.fileForm.btype,
                keyval: this.fileForm.keyval,
                tagname: this.tagName,
                tabname:this.tabName,
                docutypeid:this.docutypeid
              }
            };
            await axios.post(this.getUpload, params).then(({ data }) => {
            if (data.code == "1") {//获取附件列表
                console.log(data);
                  this.showFileList=data.data.filelist;
                  this.setUpfilesVal();
                  console.log(this.showFileList);
                } else {
                  alert(data.data.msg)
                }
              });
        },
        setUpfilesVal(){
            if(this.dataObj && this.isNotNullOrEmpty(this.dataObjAttr)){
              this.$set(this.dataObj, this.dataObjAttr, this.showFileList);
            }
        },
        uploadSuccessBack(fileId,fileName){//替换成功后的回调函数
           if (this.showFileList.length > 0) {
                for (let i = 0; i < this.showFileList.length; i++) {
                    if (this.showFileList[i].fileid == fileId) {
                       this.$set(this.showFileList[i], "name", fileName);
                       this.$set(this.showFileList[i], "filename", fileName);
                    }
                }
            }
        },
        noOpenUpload(){
          this.tipDefault(this.$t('common.nosavefiletip'));
        }
    },
    computed: {
        currentdata:{
            get:function(){
                return this.data;
            },
            set:function(val){
                this.$emit('input',val)
            }
        },
        readonly: function () {
          if(this.keyval=="")
          {
            return true;
          }
          else{
            if(this.editItem.indexOf(';'+this.matchItem+';')===-1){
              //返回true,设为只读
              return true;
            }else{
              return false;
            }
          }
        },
        nokey: function(){
          return !this.isNotNullOrEmpty(this.keyval)
        }
    },
    watch: {
      keyval:{
        handler:function(val,oldval){
          if(val!=""&&val!=undefined&&val!="0"){
            this.getupload();
          }
        },
        immediate:true
      },
      'fileForm.btype':{
        handler:function(val,oldval){
            this.initFileConfig();
        },
        immediate:true
       }
    },
    created(){
      this.initFileConfig();
    },
    mounted() {
     
    }
}



// WEBPACK FOOTER //
// ./src/pccomponents/FileUpload2.vue